import React from "react";
import * as MUI from "@mui/material";
import WarningAmberOutlinedIcon from "@mui/icons-material/WarningAmberOutlined";
import CloseIcon from "@mui/icons-material/Close";
import { useTranslation } from "react-i18next";
import { CRIMSON_RED } from "../../../../../../enums/Colors";
import ConfirmAndCancelButtons from "../../../../../../components/buttons/ConfirmAndCancelButtons";
import { useFormDeleteNoConfirm } from "../../../../../../hooks/useFormDelete";
import { WAREHOUSE_ITEMS } from "../../../../../../enums/QueryKeys";
import { GET_WAREHOUSE_ITEM } from "../../../../../../enums/ApiPaths";
import { useQueryClient } from "@tanstack/react-query";
import logger from "../../../../../../utils/logger";

export default function DeleteWarehouseItemDialog({ item, onCancel, onDeleted }) {
  const { t } = useTranslation();
  const deletion = useFormDeleteNoConfirm(GET_WAREHOUSE_ITEM, item?.id, null, 0);
  const queryClient = useQueryClient();
  async function onConfirm() {
      try {
        await deletion.submitForm();
        queryClient.invalidateQueries({ queryKey: [WAREHOUSE_ITEMS] });
        onCancel();
        onDeleted?.(item);
      } catch (err) {
        logger.error("Failed to delete warehouse item", err);
      }
    }
  return (
    <MUI.Dialog
      open={Boolean(item)}
      onClose={onCancel}
      maxWidth="xs"
      fullWidth
      PaperProps={{ sx: { borderRadius: 3 } }}
      data-testid="warehouse.items.delete-dialog"
    >
      <MUI.Stack direction="row" justifyContent="flex-end" sx={{ p: 1 }}>
        <MUI.IconButton
          onClick={onCancel}
          size="small"
          data-testid="warehouse.items.delete-dialog.close-button"
        >
          <CloseIcon fontSize="small" />
        </MUI.IconButton>
      </MUI.Stack>
      <MUI.Stack pt={0} justifyContent="center" alignItems="center">
        <MUI.Avatar
          sx={{ bgcolor: MUI.alpha(CRIMSON_RED, 0.12), width: 64, height: 64 }}
        >
          <WarningAmberOutlinedIcon
            htmlColor={CRIMSON_RED}
            sx={{ fontSize: 34 }}
          />
        </MUI.Avatar>
      </MUI.Stack>
      <MUI.DialogTitle sx={{ textAlign: "center", fontWeight: 700 }}>
        {t("DeleteWarehouseItem")}
      </MUI.DialogTitle>
      <MUI.DialogContent sx={{ textAlign: "center" }}>
        <MUI.Typography color="text.secondary" data-testid="warehouse.items.delete-dialog.message">
          {t("ReallyWantDeleteWarehouseItem", { title: item?.title })}
        </MUI.Typography>
      </MUI.DialogContent>
      <MUI.DialogActions sx={{ p: 2, pt: 0 }}>
        <ConfirmAndCancelButtons
          confirmTitle="Delete"
          cancelTitle=""
          onConfirm={() => onConfirm(item)}
          isConfirmLoading={deletion.loading}
          confirmButtonProps={{ color: "error" }}
          testId="warehouse.items.delete-dialog"
        />
      </MUI.DialogActions>
    </MUI.Dialog>
  );
}
